import asArray from '@grebban/array-utils/asArray';

const stylesToResponsiveCssPropsByKeys = (
    styleKeys: string | string[],
    objectWithStyles,
): { string: string | string[] } =>
    asArray(styleKeys).reduce((acc, key) => {
        const attributes = objectWithStyles?.[key];

        if (!attributes) {
            Object.keys(acc).forEach(attribute => {
                acc[attribute] = [...asArray(acc[attribute]), null];
            });
        } else {
            Object.keys(attributes).forEach(attribute => {
                acc[attribute] = acc[attribute]
                    ? [...asArray(acc[attribute]), attributes[attribute]]
                    : attributes[attribute];
            });
        }
        return acc;
    }, {});

export default stylesToResponsiveCssPropsByKeys;
